import React from 'react'

import { SignIn, Navbar, FooterOverlay } from '../../components'

const Signin = () => {
  return (
    <div>
      <Navbar />
      <SignIn />
      <FooterOverlay />
    </div>
  )
}

export default Signin
